var vms = vms || {};
vms.btn = vms.btn || {};

vms.btn.hightlight = function (pId) {
    $("#" + pId).addClass("t-Button--hot");
};

vms.btn.unhightlight = function (pId) {
    $("#" + pId).removeClass("t-Button--hot");
};

/* this should be the same pkg_btn.basic_html 
eg. vms.btn.gen({"id":"switchBtn","label":"Switch","fa":"far fawe-random","js":"vms.nav.switch('+ row.id +');","class":"t-Button--link"})
*/
vms.btn.gen = function (pBtn) {
    var lRet = '', lTag = 'nav';
    if (pBtn.options) {
        for (let x = 0; x < pBtn.options.length; x++) {
            var btn = pBtn.options[x];
            lRet += '<li' + (btn.id ? ' id="' + btn.id + '"' : '')
                + (btn.class ? ' class="' + btn.class + '"' : '')
                + (btn.title ? ' title="' + btn.title + '"' : '')
                + (btn.link ? '><a href="' + btn.link + '"' : (btn.js ? ' onclick="' + btn.js + '"' : ''))
                + '>' + btn.label + (btn.link ? '</a>' : '') + '</li>';
        }
        lRet = '<span class="t-Icon t-Icon--right far fawe-chevron-down"></span><ul>' + lRet + '</ul>';
    } else if (pBtn.link) {
        lTag = 'a';
    }
    lRet = '<' + lTag + ' class="t-Button' + (pBtn.class ? ' ' + pBtn.class : '') + 
          (pBtn.fa || pBtn.options ? ' t-Button--icon' : '') +
          (pBtn.fa ? ' t-Button--iconLeft t-Button--mobileHideLabel' : '') +
          (pBtn.options ? ' t-Button--dropdown  t-Button--icon t-Button--iconRight' : '') +
          '"'+
          (lTag == 'a' && pBtn.newWindow ? ' target="_blank"' : '')
        + (pBtn.id ? ' id="' + pBtn.id + '"' : '')
        + (pBtn.title ? ' title="' + pBtn.title + '"' : '')
        + (pBtn.link ? ' href="' + pBtn.link + '"' : (pBtn.js ? ' onclick="' + pBtn.js + '"' : ''))
        + '>'
        + (pBtn.fa ? '<span class="t-Icon t-Icon--left ' + pBtn.fa + '"></span>' : '')
        + (pBtn.label ? '<span class="t-Button-label">' + pBtn.label + '</span>' : '')
        + lRet + '</' + lTag + '>';
    return lRet;
};
vms.btn.genAll = function (pBtns){
    var lRet = '';
    for (let i = 0; i < pBtns.length; i++) {
        lRet += vms.btn.gen(pBtns[i]);
    }
    return lRet;
};

// TODO cleanup after we ditch the old app
var hightlightButton = vms.btn.hightlight;
var unhightlightButton = vms.btn.unhightlight;
var deleteHighligh = vms.btn.unhightlight;